import { CustomHeader } from "components/universal/custom-header";
import { useTranslation } from "react-i18next";
import { ResetAccessPageView } from "views/reset-access";

export const ResetAccessPage = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'SEO.resetPasswordPage',
    });
    
    return (
        <>
            <CustomHeader title={t('title')} />
            <ResetAccessPageView />
        </>
    );
};
